import { RouteRecordRaw } from "vue-router";
import { UserRoleEnum } from "@/app/core/enums/UserRoleEnum";

export const routePrivateSearch: Array<RouteRecordRaw> = [
  {
    path: "search",
    name: "Search",
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Shipper, UserRoleEnum.Carrier, UserRoleEnum.Master],
    },
    redirect: (to) => {
      return { name: "SearchListings" };
    },
    component: () => import("@/app/private/pages/search-for-orders/SearchForOrders.vue"),
    children: [
      {
        path: "",
        name: "SearchListings",
        component: () =>
          import(
            "@/app/private/pages/search-for-orders/pages/listings/SearchForOrdersListings.vue"
          ),
      },
    ],
  },
];
